import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Provider, connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import {
  CACHE_CUSTOMER_NUMBER,
  CACHE_AMOUNT,
  CACHE_FROM_TNC,
  CACHE_FROM_PAYMENT,
} from 'constant/ConstVariable';
import { Loading } from 'components';
import { IntlProvider } from 'react-intl';
import { ROUTERS, STORE, HELPER, JsBridge, Sentry } from 'utils';
import { init as initMixpanel } from 'utils/Mixpanel';

import UnavailablePage from 'containers/UnavailablePage/UnavailablePage.container';

import translation from 'constant/translations';
import { Integrations } from '@sentry/tracing';
import {
  setDeviceHeight,
  getAuthToken,
  setLoading,
  setErrorState,
  setAdditionalInfo,
} from 'redux/actions/GeneralAction';
import packageInfo from '../package.json';
import * as serviceWorker from './serviceWorker';
import withClearCache from './cache';
import './index.less';

if (!window.location.hostname.includes('localhost')) {
  Sentry.init({
    dsn: process.env.SENTRY_URL,
    environment: process.env.ENV,
    release: packageInfo.version,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: parseFloat(process.env.SENTRY_TRACES_RATE),
  });
}
class Main extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isToken: false,
    };
  }

  initAuthToken = () => {
    const credsOwner = window.location.pathname
      .substring(1)
      .replace('biller/', '');
    const getAuthCode =
      HELPER.getParamURL('authCode') || HELPER.getParamURL('auth_code');
    const danaEnv = HELPER.getParamURL('env');
    const getRequestID = HELPER.getParamURL('requestId') || HELPER.createUUID();

    const authParam = {
      auth_code: getAuthCode,
      dana_env: danaEnv,
      dana_creds_owner: credsOwner,
      request_id: getRequestID,
    };
    // Check App Is User Authenticated Or Not
    this.props
      .getAuthToken(authParam)
      .then(() => {
        // Mixpanel Init
        initMixpanel();
        // Cache Removing
        sessionStorage.removeItem(CACHE_CUSTOMER_NUMBER);
        sessionStorage.removeItem(CACHE_AMOUNT);
        sessionStorage.removeItem(CACHE_FROM_TNC);
        sessionStorage.removeItem(CACHE_FROM_PAYMENT);
        // Set Addtional Biller Info
        this.props.setAdditionalInfo({
          dgos_goods_id: HELPER.getParamURL('goodsId'),
        });
        this.setState({ isToken: true }, () => this.props.setErrorState(false));
      })
      .catch(() => {
        this.props.setErrorState(true);
      });
  };

  getAuth = () => {
    // Create Route Exception
    const exception = ['invoice', 'session-end'];
    const last = window.location.href.substring(
      window.location.href.lastIndexOf('/') + 1,
    );
    let isException = false;
    for (let i = 0; i < exception.length; i += 1) {
      const item = exception[i];
      if (last.includes(item)) {
        isException = true;
      }
    }
    // Validate Router Exception
    if (isException) {
      this.setState({ isToken: true }, () => this.props.setErrorState(false));
    } else {
      this.initAuthToken();
    }
  };

  componentDidMount() {
    try {
      document.addEventListener(
        'AlipayJSBridgeReady',
        () => {
          JsBridge.setTitle('DANA');
          JsBridge.setDefaultBack();
          JsBridge.on('resume', JsBridge.setDefaultBack);
        },
        false,
      );
      this.props.setDeviceHeight(window.innerHeight);
      const isOnDebug = window.location.hostname === 'localhost';
      if (window.IS_IN_SKYWALKER || window.IS_IN_PLAYGROUND || isOnDebug) {
        this.getAuth();
      } else {
        throw new Error('Unknown User Agent');
      }
    } catch (error) {
      Sentry.captureMessage(error);
      this.props.setErrorState(true);
    }
  }
  _renderRouter = () => (
    <Router>
      <Switch>
        {ROUTERS.map(route => (
          <Route key={route.id} {...route} />
        ))}
      </Switch>
    </Router>
  );
  render() {
    const { isLoading, isError, maintenace } = this.props;
    if (get(maintenace, 'isMaintenance')) {
      return <UnavailablePage description={get(maintenace, 'description')} />;
    }
    if (isError) {
      return <UnavailablePage isUnauthorized />;
    }

    return (
      <>
        <Loading {...{ isLoading }} />
        {this.state.isToken ? this._renderRouter() : ''}
      </>
    );
  }
}

Main.propTypes = {
  isError: PropTypes.bool,
  isLoading: PropTypes.bool,
  setDeviceHeight: PropTypes.func,
  setAdditionalInfo: PropTypes.func,
  getAuthToken: PropTypes.func,
  setLoading: PropTypes.func,
  setErrorState: PropTypes.func,
  maintenace: PropTypes.object,
};

// Main Loading Will Hook For Any Container
const mapStateToProps = state => ({
  isLoading: state.general.isLoading,
  isError: state.general.isError,
  maintenace: state.general.maintenance,
});

const MainConnect = connect(
  mapStateToProps,
  {
    setDeviceHeight,
    getAuthToken,
    setLoading,
    setErrorState,
    setAdditionalInfo,
  },
)(Main);

const App = () => (
  <Provider store={STORE}>
    <IntlProvider
      locale={HELPER.getLang()}
      messages={translation[HELPER.getLang()]}
    >
      <MainConnect />
    </IntlProvider>
  </Provider>
);
const SentryProfiler = Sentry.withProfiler(App);
const ClearCacheComponent = withClearCache(SentryProfiler);

ReactDOM.render(<ClearCacheComponent />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
